module.exports = __webpack_public_path__ + "img/2.bd58a06d.jpg";